<div class="container-fluid">
	<!-- HEADER COMPONENT -->
	<reports-header [phase]="selectedPhase" class="mb-4"></reports-header>

	<!-- PHASE1: BODY COMPONENT -->
	@if (selectedPhase === 1) {
		<reports-body (phaseChange)="onPhaseChange($event)" class="mb-4"></reports-body>
	}

	<!--#region PHASE 2: FORMS -->
	<!-- LICENSE REPORT -->
	@if (selectedPhase === 2 && reportData.reportData.reportType === 'DRIVERS_EXPIRATION') {
		<app-license-report-form [report]="reportData" (phaseChange)="onPhaseChange($event)"></app-license-report-form>
	}

	<!-- INSURANCE REPORT -->
	@if (selectedPhase === 2 && reportData.reportData.reportType === 'INSURANCE_ACTIVE') {
		<app-insurance-report-form
			[report]="reportData"
			(phaseChange)="onPhaseChange($event)"
		></app-insurance-report-form>
	}
	<!--#endregion-->

	<!-- VEHICLE ACCESORY REPORT -->
	@if (selectedPhase === 2 && reportData.reportData.reportType === 'VEHICLE_ACCESORY') {
		<app-vehicle-accesory-report-form
			[report]="reportData"
			(phaseChange)="onPhaseChange($event)"
		></app-vehicle-accesory-report-form>
	}

	<!-- FINES REPORT -->
	@if (selectedPhase === 2 && reportData.reportData.reportType === 'FINES') {
		<app-fines-report-form [report]="reportData" (phaseChange)="onPhaseChange($event)"></app-fines-report-form>
	}

	<!-- VEHICLE CONSUMPTION REPORT -->
	@if (selectedPhase === 2 && reportData.reportData.reportType === 'VEHICLE_CONSUMPTION') {
		<app-vehicle-consumption-report-form
			[report]="reportData"
			(phaseChange)="onPhaseChange($event)"
		></app-vehicle-consumption-report-form>
	}

	<!-- CARDS REPORT -->
	@if (selectedPhase === 2 && reportData.reportData.reportType === 'CARD') {
		<app-cards-report-form [report]="reportData" (phaseChange)="onPhaseChange($event)"></app-cards-report-form>
	}

	<!-- ITV EXPIRATION REPORT -->
	@if (selectedPhase === 2 && reportData.reportData.reportType === 'ITV_EXPIRATION') {
		<app-itv-expiration-report-form
			[report]="reportData"
			(phaseChange)="onPhaseChange($event)"
		></app-itv-expiration-report-form>
	}

	<!-- VEHICLE EXPIRATION REPORT -->
	@if (selectedPhase === 2 && reportData.reportData.reportType === 'VEHICLE_EXPIRATION') {
		<app-vehicle-expiration-report-form
			[report]="reportData"
			(phaseChange)="onPhaseChange($event)"
		></app-vehicle-expiration-report-form>
	}

	<!-- VEHICLE REPORT -->
	@if (selectedPhase === 2 && reportData.reportData.reportType === 'VEHICLE') {
		<app-vehicle-report-form [report]="reportData" (phaseChange)="onPhaseChange($event)"></app-vehicle-report-form>
	}

	@if (selectedPhase === 2 && reportData.reportData.reportType === 'NIIF') {
		<app-niif-report-form [report]="reportData" (phaseChange)="onPhaseChange($event)"></app-niif-report-form>
	}

	@if (selectedPhase === 2 && reportData.reportData.reportType === 'CECO') {
		<app-ceco-report-form [report]="reportData" (phaseChange)="onPhaseChange($event)"></app-ceco-report-form>
	}

	@if (selectedPhase === 2 && reportData.reportData.reportType === 'SINISTER') {
		<app-sinister-report-form [report]="reportData" (phaseChange)="onPhaseChange($event)"></app-sinister-report-form>
	}

	@if (selectedPhase === 2 && reportData.reportData.reportType === 'BREAKDOWN') {
		<app-breakdown-report-form
			[report]="reportData"
			(phaseChange)="onPhaseChange($event)"
		></app-breakdown-report-form>
	}

	@if (selectedPhase === 2 && reportData.reportData.reportType === 'SANCTION') {
		<app-sanction-report-form [report]="reportData" (phaseChange)="onPhaseChange($event)"></app-sanction-report-form>
	}

	<!-- #endregion PHASE: 2 FORMS -->

	<!-- #endregion PHASE: 2 FORMS -->

	<!-- PHASE3: REPORT GENERATOR -->
	@if (selectedPhase === 3) {
		<app-report-generator
			[reportName]="selectedReportName"
			[report]="reportData"
			(phaseChange)="onPhaseChange($event)"
		></app-report-generator>
	}
</div>
